var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("appointment-complete", {
    attrs: {
      "complete-appointment": _vm.completeAppointment,
      "get-appointment-info": _vm.getAppointmentInfo,
      "get-appointment-locations": _vm.getAppointmentLocations,
      "get-appointment-municipalities": _vm.getMunicipalities,
      "get-appointment-therpies": _vm.getAppointmentTherpies,
      "get-diagnostics": _vm.getDiagnostics,
      "get-frequency-type": _vm.getFrequencyType,
      "get-reasons-apointment-status": _vm.getReasonsApointmentStatus,
      "get-reevaluation-times": _vm.getReevaluationTimes,
      "get-service-modalities": _vm.getServiceModalities,
      "get-services": _vm.getTherapyServices,
      "get-specialist-by-location": _vm.getSpecialistByLocation,
      "get-specialist-practitioners": _vm.getSpecialistPractitioners,
      "get-sysparameter-by-names": _vm.getSysparameterByNames,
      "get-therapy-durations": _vm.getTherapyDurations,
      "input-options": _vm.getInputOptions,
      "search-diagnostics-excluding-student":
        _vm.searchDiagnosticsExcludingStudent
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }